import { Link } from 'react-router-dom';
import type { HostedEnvironment, SiteState } from '../../api';
import { statusFor } from '../../labels';

/**
 * HostedEnvironments names what runs on a server (UX-16): each environment
 * with its project, its live site's state (CO-150) and a link into it.
 */
const dot: Record<SiteState, 'ok' | 'warning' | 'critical' | 'unknown'> = { operational: 'ok', degraded: 'warning', unavailable: 'critical', unknown: 'unknown' };

export function HostedEnvironments({ environments, limit }: { environments: HostedEnvironment[]; limit?: number }) {
  if (environments.length === 0) return <span className="muted">Nothing placed here</span>;
  const shown = limit ? environments.slice(0, limit) : environments;
  const rest = environments.length - shown.length;
  return (
    <ul className="hosted-list" aria-label="Hosted environments">
      {shown.map((env) => (
        <li key={env.environment_id} className="hosted-list__item">
          <span className={`level-dot level-dot--${dot[env.site ?? 'unknown']}`} aria-hidden="true" />
          <span className="visually-hidden">Site {statusFor('siteState', env.site ?? 'unknown').label.toLowerCase()}: </span>
          <Link to={`/app/projects/${env.project_id}/overview?env=${encodeURIComponent(env.environment_slug)}`}>
            {env.project_name} · {env.environment_name}
          </Link>
          {!limit && env.components.length > 0 ? <span className="muted"> — {env.components.join(', ')}</span> : null}
        </li>
      ))}
      {rest > 0 ? <li className="hosted-list__more muted">and {rest} more</li> : null}
    </ul>
  );
}
